//#region types
import { ApiClientInstance } from "utils/helpers";
import { AuthEnums } from "models/enums";
//#endregion
import { ServiceConstants } from "utils/constants";

/**
 * @deprecated This service is deprecated. Use useBusinessUnitService hook instead.
 *
 * @see useBusinessUnitService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const BusinessUnitService = {
  searchBusinessUnits: async (searchStr?: string) => {
    return ApiClientInstance(AuthEnums.AuthType.Company)
      .BusinessUnitsClient.GetByFilter({
        ...ServiceConstants.DefaultFilter,
        searchStr: searchStr,
      })
      .then((res) => {
        return res.data?.items ?? [];
      });
  },
};

export default BusinessUnitService;
